import React from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { FiX, FiZoomIn, FiZoomOut } from 'react-icons/fi';

const ImageLightbox = ({ imageUrl, onClose }) => {
    const { t } = useTranslation();
    const [scale, setScale] = React.useState(1);

    const handleZoomIn = () => setScale(prev => Math.min(prev + 0.5, 3));
    const handleZoomOut = () => setScale(prev => Math.max(prev - 0.5, 0.5));

    // Portaled to <body> so the fullscreen viewer escapes any transformed parent
    // modal (e.g. a MediaGallery embedded in JobCardModal) that would otherwise
    // become the containing block for this fixed overlay and clip it.
    return createPortal(
        <div
            className="fixed inset-0 z-[60] flex items-center justify-center bg-black/90 backdrop-blur-sm"
            onClick={onClose}
        >
            <button
                onClick={onClose}
                className="absolute top-[max(1rem,env(safe-area-inset-top))] end-4 w-11 h-11 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors z-10"
                aria-label={t('cm.actions.close')}
            >
                <FiX size={24} />
            </button>

            <div className="absolute top-[max(1rem,env(safe-area-inset-top))] start-4 flex gap-2 z-10">
                <button
                    onClick={(e) => { e.stopPropagation(); handleZoomIn(); }}
                    className="w-11 h-11 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors"
                    aria-label={t('cm.lightbox.zoomIn')}
                >
                    <FiZoomIn size={20} />
                </button>
                <button
                    onClick={(e) => { e.stopPropagation(); handleZoomOut(); }}
                    className="w-11 h-11 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors"
                    aria-label={t('cm.lightbox.zoomOut')}
                >
                    <FiZoomOut size={20} />
                </button>
            </div>

            <div
                className="overflow-auto max-w-[90vw] max-h-[90vh]"
                onClick={(e) => e.stopPropagation()}
            >
                <img
                    src={imageUrl}
                    alt={t('cm.lightbox.fullSizeAlt')}
                    className="transition-transform duration-200"
                    style={{ transform: `scale(${scale})` }}
                />
            </div>
        </div>,
        document.body
    );
};

export default ImageLightbox;
